import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { TextField, InputAdornment } from '@material-ui/core/'
import { Visibility, VisibilityOff } from '@material-ui/icons/'
import arrowMessage from '../../../assetss/img/arrowMessage.svg'
import closeEdit from '../../../assetss/img/closeEdit.svg'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
    },
    borderRadius: '8px',
    '& .Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #E85A50',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #525E69',
      borderRadius: '8px',
    },
    '& input': {
      height: '48px',
      padding: '0 0 0 20px',
      margin: 0,
    },
    '& .MuiFormHelperText-root': {
      textAlign: 'right',
      margin: '0 !important',
    },
  },
  editText: {
    width: '100%',
    height: '24px',
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  editMessage: {
    marginLeft: '15px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#252525',
  },
  closeEdit: {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
    borderRight: '1px solid #525E69',
    paddingRight: '11px',
  },
}))

const Input = ({
  label,
  id,
  name,
  type = 'text',
  placeholder,
  value,
  customClass,
  onChange,
  helperText,
  error,
  maxLength,
  endAdornment,
  customIcon,
  onSubmit,
  handleKeyDown,
  endPass,
  onPass,
  visiblePass,
  text,
  editTextMess,
  onCloseEdit,
  onEditMess,
  fullWidth,
}) => {
  const classes = useStyles()

  return (
    <div className={customClass}>
      <TextField
        fullWidth={fullWidth}
        id={id}
        label={label}
        variant='outlined'
        placeholder={placeholder}
        value={value}
        name={name}
        type={type}
        className={classes.root}
        onChange={onChange}
        helperText={helperText}
        error={error}
        inputProps={{ maxLength: maxLength }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onSubmit()
          }
        }}
        InputProps={{
          startAdornment: text && <img onClick={onCloseEdit} className={classes.closeEdit} src={closeEdit} />,
          endAdornment: !text && endAdornment && <InputAdornment onClick={onSubmit} position='end'>{endPass ? visiblePass ? <Visibility style={{ cursor: 'pointer' }} onClick={onPass} /> : <VisibilityOff style={{ cursor: 'pointer' }} onClick={onPass} /> : <img className={customIcon} src={arrowMessage} />}</InputAdornment>,
        }}
      />
      {/* {!onEditMess && <div className={classes.editText}><span className={classes.editMessage}>{editTextMess}</span> {text && <img onClick={onSubmit} style={{ marginRight: '30px' }} className={customIcon} src={arrowMessage} />}</div>} */}
    </div>
  )
}

export default Input
